"use client";

import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

const Progress = React.forwardRef(({ className, value, height = "h-4", ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={
      `relative ${height} w-full overflow-hidden rounded-full bg-gray-300 ` +
        (className || "")
    }
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 bg-[#3E5FFF] transition-all"
      style={{ width: `${value}%` }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
